const reviewTypes = {
  review: "review",
  communications: "communications",
};

export default reviewTypes;
